import { useState } from 'react';
import { useSearchParamsWithApiKey, useDebouncedEffect } from '../../tools';

interface UseAdjustForSurfaceParams {
    document: string;
    surfaceSpecificationUrl: string;
    surfaceSpecification: any;
    targetSubstrateColor: string;
    useV0: boolean;
    setDocument: (document: string) => void;
    setSurfaceSpecificationUrl: (url: string) => void;
    setSurfaceSpecification: (surfaceSpec: any) => void;
    setTargetSubstrateColor: (targetSubstrateColor: string) => void;
    setUseV0: (useV0: boolean) => void;
}

export const useAdjustForSurfaceParams = (): UseAdjustForSurfaceParams => {
    const [searchParams, setSearchParams] = useSearchParamsWithApiKey();

    const documentUrl = searchParams.get('documentUrl');
    const surfaceSpecificationParam = searchParams.get('surfaceSpecification');
    const surfaceSpecificationUrlParam = searchParams.get('surfaceSpecificationUrl');
    const substrateColor = searchParams.get('targetSubstrateColor');

    const [document, setDocument] = useState(documentUrl || '');
    const [surfaceSpecificationUrl, setSurfaceSpecificationUrl] = useState(surfaceSpecificationUrlParam || '');
    const [surfaceSpecification, setSurfaceSpecification] = useState(
        surfaceSpecificationParam ? JSON.parse(surfaceSpecificationParam) : undefined,
    );
    const [targetSubstrateColor, setTargetSubstrateColor] = useState(substrateColor || '');
    const [useV0, setUseV0] = useState(searchParams.get('useV0') === 'true');

    useDebouncedEffect(
        () => {
            const searchParamsObj: Record<string, string> = {};

            if (document) {
                searchParamsObj['documentUrl'] = document;
            }

            if (surfaceSpecificationUrl) {
                searchParamsObj['surfaceSpecificationUrl'] = surfaceSpecificationUrl;
            }

            if (surfaceSpecification) {
                searchParamsObj['surfaceSpecification'] = JSON.stringify(surfaceSpecification);
            }

            if (targetSubstrateColor) {
                searchParamsObj['targetSubstrateColor'] = targetSubstrateColor;
            }

            if (useV0) {
                searchParamsObj['useV0'] = 'true';
            }

            setSearchParams(searchParamsObj, { replace: true });
        },
        [document, surfaceSpecificationUrl, surfaceSpecification, targetSubstrateColor, useV0, setSearchParams],
        500,
    );

    return {
        document,
        surfaceSpecificationUrl,
        surfaceSpecification,
        targetSubstrateColor,
        useV0,
        setDocument,
        setSurfaceSpecificationUrl,
        setSurfaceSpecification,
        setTargetSubstrateColor,
        setUseV0,
    };
};
